var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { Getter, State, Mutation } from 'vuex-class';
import logger from '@plat-components/utils2/_esm5/logger';
let Page8 = class Page8 extends Vue {
    constructor() {
        super(...arguments);
        this.inf = window.inf || false;
        this.isPC = window.isPC || false;
    }
    get typeImg() {
        let img = '';
        if (this.page8 && this.page8.alias_flag) {
            img = require(`../assets/page8/final-type-${this.page8.alias_flag}.png`);
        }
        return img;
    }
    get eyeImg() {
        const onImg = require('../assets/page8/eye-on.png');
        const closeImg = require('../assets/page8/eye-close.png');
        return this.showInfo ? onImg : closeImg;
    }
    handleToggleClick() {
        if (this.showInfo) {
            logger('button_hide');
        }
        else {
            logger('button_not_hide');
        }
        // eslint-disable-next-line babel/new-cap
        this.TOGGLE_SHOWINFO(!this.showInfo);
    }
};
__decorate([
    Getter
], Page8.prototype, "page8", void 0);
__decorate([
    Getter
], Page8.prototype, "hideTop", void 0);
__decorate([
    State
], Page8.prototype, "userInfo", void 0);
__decorate([
    State
], Page8.prototype, "showInfo", void 0);
__decorate([
    Mutation
], Page8.prototype, "TOGGLE_SHOWINFO", void 0);
Page8 = __decorate([
    Component
], Page8);
export default Page8;
